import { axiosClient } from '../axiosClient';

export type LoginRequest = {
  email: string;
  password: string;
};

export type LoginResponse = {
  token: string;
  manager: {
    id: number;
    name: string;
    email: string;
    role: 'super_admin' | 'admin' | 'viewer';
  };
};

export type Manager = {
  id: number;
  name: string;
  email: string;
  role: 'super_admin' | 'admin' | 'viewer';
  created_at: string;
  last_login: string;
};

export const authApi = {
  login: async (credentials: LoginRequest): Promise<LoginResponse> => {
    const response = await axiosClient.post<LoginResponse>('/manager/auth/login', credentials);
    return response.data;
  },

  logout: async (): Promise<void> => {
    await axiosClient.post('/manager/auth/logout');
  },

  getMe: async (): Promise<{ manager: Manager }> => {
    const response = await axiosClient.get<{ manager: Manager }>('/manager/auth/me');
    return response.data;
  },
};
